export default __webpack_public_path__ + "static/media/nicholas.eca41726.png";